import filterIcon from "@src/assets/svg/filter-icon.svg";
import filterIconClear from "@src/assets/svg/filter-icon-clear.svg";
import filterIconDisabled from "@src/assets/svg/filter-icon-disabled.svg";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { useEffect, useState } from "react";
import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { useI18N } from "@src/language/language-context";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

export const useFilterIconNewInitialStructureHook = () => {
  const i18n = useI18N();
  const texts = {
    tooltip: i18n("modules.filterIcon.tooltip"),
    clearButtonTooltip: i18n("modules.filterIcon.clearButtonTooltip"),
    clearButtonText: i18n("modules.filterIcon.clearButtonText"),
  };

  const logger = getLogger();
  const initialStructureNodeset = getInitialStructureNodeset();
  const filteredNodeData = initialStructureNodeset.getFilteredFlatMap();
  const selectedNodeData = initialStructureNodeset.getFlatMap();

  const [filteredNodesCount, setFilteredNodesCount] = useState(0);
  const [showFilter, setShowFilter] = useState(false);

  const activeNodeId = useSelector(
    (state: RootState) => state.yourSlice.activeInitialStructureNode,
  );

  const handleClickFilterFunction = () => {
    logger.debug("useFilterIconNewInitialStructureHook", {
      function: "handleClickFilterFunction",
    });
    return getNodeManager().handleClickNewFilterInitial();
  };

  const handleClickClearFilterListFunction = () => {
    logger.debug("useFilterIconNewInitialStructureHook", {
      function: "handleClickClearFilterListFunction",
    });
    return getNodeManager().clearFilterNewForInitialList();
  };

  const handleReturnedIconForFilter = () => {
    let icon;
    if (
      selectedNodeData === null ||
      (filteredNodeData.size === 0 && selectedNodeData.size === 0)
    ) {
      icon = filterIconDisabled;
    } else if (!showFilter) {
      return filterIcon;
    } else if (showFilter) {
      return filterIconClear;
    }
    return icon;
  };

  useEffect(() => {
    if (selectedNodeData === null) {
      setShowFilter(false);
    }
  }, []);

  useEffect(() => {
    const updateFilterbutton = () => {
      const newFilteredNodesCount =
        initialStructureNodeset.getFilteredFlatMap().size;
      logger.debug("useFilterIconNewInitialStructureHook", {
        function: "updateFilterbutton",
        newFilteredNodesCount: newFilteredNodesCount,
      });
      setFilteredNodesCount(initialStructureNodeset.getFilteredFlatMap().size);
      setShowFilter(initialStructureNodeset.getShowFilterPanel());
    };

    initialStructureNodeset.addObserver(updateFilterbutton);

    return () => {
      initialStructureNodeset.removeObserver(updateFilterbutton);
    };
  }, [initialStructureNodeset]);

  return {
    filterIconSvgString: handleReturnedIconForFilter(),
    handleClickClearFilterListFunction: handleClickClearFilterListFunction,
    handleClickFilterFunction: handleClickFilterFunction,
    iconButtonText: filteredNodesCount ? `${filteredNodesCount}` : "",
    iconButtonVariant: showFilter ? "green-background" : "",
    isApplyMarginLeft: showFilter ? true : false,
    isIconButtonDisabled:
      selectedNodeData === undefined || selectedNodeData === null
        ? true
        : false,
    isShowClearButton: showFilter ? true : false,
    texts: texts,
  };
};
